import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DataSelectorDirective } from '../../../directives/data-selector/data-selector.directive';
import { FileModel } from '../../../models';
import { SharedModule } from '../../../shared.module';
import { isSupportedExtension } from '../utils/file-extension.util';

interface SidebarRow {
  index: number;
  name: string;
  supported: boolean;
}

@Component({
  selector: 'app-file-preview-sidebar',
  templateUrl: './file-preview-sidebar.component.html',
  styleUrls: ['./file-preview-sidebar.component.scss'],
  imports: [SharedModule, DataSelectorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilePreviewSidebarComponent {
  readonly files = input.required<Partial<FileModel>[]>();
  readonly currentIndex = input.required<number>();

  readonly fileSelected = output<number>();

  protected readonly rows = computed<SidebarRow[]>(() =>
    this.files().map((file, index) => ({
      index,
      name: file?.name ?? '',
      supported: isSupportedExtension(file?.name),
    })),
  );

  protected onSelect(index: number): void {
    if (index !== this.currentIndex()) {
      this.fileSelected.emit(index);
    }
  }

  protected trackByIndex(_: number, row: SidebarRow): number {
    return row.index;
  }
}
